/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmUsageVectorStores } from "../../funcs/llmUsageVectorStores.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetVectorStoresUsageRequest$inboundSchema,
};

export const tool$llmUsageVectorStores: ToolDefinition<typeof args> = {
  name: "llm-usage-vector-stores",
  description: `Get vector stores usage

Retrieve usage metrics for vector storage operations.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmUsageVectorStores(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
